module.exports = __webpack_public_path__ + "img/egalim.fc7d11be.svg";